import React from 'react'
import Message from '../../components/Message'

const Chat = () => {
  return (
    <div><Message/></div>
  )
}

export default Chat